<template>
  <el-menu-item :index="menuItem.name" v-if="menuItem.path" v-show="isShowMenu">
    <div class="menu-item-title-wrap">
      <i :class="itemIcon"></i>
      <span slot="title">{{menuItem.label}}</span>
    </div>
  </el-menu-item>
  <li class="element-menu-wrap" v-else-if="itemList.length > 0" v-show="isShowMenu">
    <ul class="element-submenu-wrap">
      <el-submenu :index="menuItem.id">
        <div slot="title" class="submenu-title-wrap">
          <i :class="itemIcon"></i>
          <span slot="title">{{menuItem.label}}</span>
        </div>
        <ElementMenu ref="subMenus"
                     v-for="(item, index) in itemList"
                     :key="'element-menu-' + index"
                     :menu-item="item"
                     :menu-data-list="menuDataList"
                     :filter-key="filterKey"></ElementMenu>
      </el-submenu>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'ElementMenu',
  props: {
    menuItem: Object,
    menuDataList: Array,
    filterKey: String
  },
  data () {
    return {
      showSubMenu: false
    }
  },
  computed: {
    itemList: function () {
      return this.menuDataList.filter(data => data.parentId === this.menuItem.id)
    },
    itemIcon: function () {
      if (!this.menuItem.parentId && this.menuItem.icon) {
        return this.menuItem.icon
      }
      return 'iconfont icon-file'
    },
    isShowMenu: function () {
      if (this.menuItem.path) {
        if (this.filterKey) {
          return (this.menuItem.label || '').match(new RegExp(this.filterKey, 'i'))
        } else {
          return true
        }
      } else {
        return this.showSubMenu
      }
    }
  },
  methods: {
    validateSubMenu () {
      this.$nextTick(() => {
        let subMenus = this.$refs['subMenus']
        if (subMenus) {
          this.showSubMenu = subMenus.some(menu => menu.isShowMenu)
        } else {
          this.showSubMenu = false
        }
      })
    }
  },
  mounted () {
    this.validateSubMenu()
  },
  updated () {
    this.validateSubMenu()
  }
}
</script>

<style lang="scss">
  .element-menu-wrap {
    & > .element-submenu-wrap {
      list-style: none;
      margin: 0;
      padding-left: 0;
    }
  }
  .el-menu {
    &.el-menu--collapse {
      .element-menu-wrap {
        .el-submenu {
          & > .el-submenu__title {
            span {
              height: 0;
              width: 0;
              overflow: hidden;
              visibility: hidden;
              display: inline-block;
            }
            .el-submenu__icon-arrow {
              display: none;
            }
          }
        }
      }
    }
  }
</style>
